import React from 'react';
import moment from 'moment';
import Countdown from 'react-countdown';
import { CountdownClock } from './countdown-clock';

export const CountdownMain = () => (
    <Countdown date={moment("2020-11-27T15:00:00")} renderer={CountdownClock} />
);